import { InputHTMLAttributes, PropsWithChildren } from 'react';
import { v4 as uuidv4 } from 'uuid';
import styles from './Checkbox.module.scss';
import { classnames } from '../../utils';

type CheckboxProps = {
  fontSize?: number;
  readonly?: boolean;
};

type Props = React.PropsWithChildren<CheckboxProps> & InputHTMLAttributes<HTMLInputElement>;

export default function Checkbox({ children, fontSize = 14, readonly, ...rest }: Props) {
  const id = rest.id ?? uuidv4();

  return (
    <>
      <input
        className={classnames([styles.checkbox, readonly && styles.readonly])}
        type="checkbox"
        name={rest.name}
        id={id}
        {...rest}
      />
      <label
        className={styles.label}
        htmlFor={id}
        style={{ fontSize: `var(--font-${fontSize})`, '--checkbox-size': `${fontSize + 2}px` } as React.CSSProperties}
      >
        {children && <span>{children}</span>}
      </label>
    </>
  );
}

type ToggleProps = {
  scope?: string;
  onChange: () => void;
} & PropsWithChildren<InputHTMLAttributes<HTMLInputElement>>;

export const Toggle = ({ scope = 'toggle', onChange, checked, children, ...rest }: ToggleProps) => {
  const id = `switch-${scope || 'toggle'}`;

  return (
    <div className={classnames([styles.toggle, rest.disabled && 'opacity-5'])}>
      <input onChange={onChange} checked={checked} type="checkbox" id={id} {...rest} />
      <label htmlFor={id}></label>
      <div className={`${styles.fauxLabel} ${rest.disabled ? 'pe-none grey-700' : ''}`} onClick={onChange}>
        {children}
      </div>
    </div>
  );
};
